import { Env } from "./Env";

export const isDevStage = () => Env.appEnv === "dev";
export const isBetaStage = () => Env.appEnv === "beta";
export const isProdStage = () => Env.appEnv === "prod";
export const isTestStage = () => Env.appEnv === "test";
export const isNonProdStage = () => !isProdStage();
export const isDevOrTestStage = () => isDevStage() || isTestStage();
export const isProductionLikeStage = () => isBetaStage() || isProdStage();
